import {
  Create,
  Datagrid,
  // Edit,
  List,
  // SaveButton,
  SimpleForm,
  TextField,
  TextInput,
  // Toolbar,
  // EditButton,
  DateField,
  Show,
  // SimpleShowLayout,
  // RichTextField,
  // ReferenceField,
  ShowButton,
  useRecordContext,
  // Filter,
  SelectInput,
  // DateInput,
  useNotify,
  useRedirect,
  // useDataProvider,
  // useGetList,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  useGetOne,
} from "react-admin";
import { Box, Card, CardContent, Divider, Grid, IconButton, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import UserDialog from "./components/user-details";
import TradeItemDialog from "./components/trade-item-dialog";
import { useIsManager, ReadOnlyListActions } from "./components/manager-read-only";



// Define the filters
const negotiationsFilters = [
  <TextInput
    label="Search Buyer/Seller"
    source="search"
    alwaysOn
    placeholder="Search by name or phone"
    className="w-full p-2 border rounded-lg shadow-sm"
  />,
  <SelectInput
    label="Negotiation Type"
    source="type"
    choices={[
      { id: "", name: "All" },
      { id: "Crop", name: "Crop" },
      { id: "Input", name: "Input" },
      { id: "Service", name: "Service" },
    ]}
    alwaysOn
    optionText="name"
    optionValue="id"
    className="w-full p-2 border rounded-lg shadow-sm"
  />,
  <SelectInput
    label="Trade Type"
    source="tradeType"
    choices={[
      { id: "", name: "All" },
      { id: "Offer", name: "Offer" },
      { id: "Demand", name: "Demand" },
    ]}
    alwaysOn
    optionText="name"
    optionValue="id"
    className="w-full p-2 border rounded-lg shadow-sm"
  />,
  <SelectInput
    label="Status"
    source="status"
    choices={[
      { id: "", name: "All" },
      { id: "Active", name: "Active" },
      { id: "Finalized", name: "Finalized" },
      { id: "Rejected", name: "Rejected" },
    ]}
    alwaysOn
    optionText="name"
    optionValue="id"
    className="w-full p-2 border rounded-lg shadow-sm"
  />,
];

export const NegotiationsList = (props) => {
  const isManager = useIsManager();
  return (
  <List
    className="mt-10"
    {...props}
    filters={negotiationsFilters}
    perPage={25}
    actions={isManager ? <ReadOnlyListActions /> : undefined}
  >
    <Datagrid
      rowClick="show"
      className="border rounded-lg shadow-lg overflow-hidden mt-4"
    >
      <TextField
        source="id"
        label="ID"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="type"
        label="Type"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="tradeType"
        label="Trade Type"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="quantity"
        label="Quantity"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="buyer.name"
        label="Buyer"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="seller.name"
        label="Seller"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <TextField
        source="status"
        label="Status"
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <DateField
        source="createdAt"
        label="Created At"
        showTime
        className="p-3 border-b hover:bg-gray-50 transition-colors"
      />
      <ShowButton className="p-3 border-b hover:bg-gray-50 transition-colors" />
    </Datagrid>
  </List>
  );
};


const MessagesList = () => {
  const record = useRecordContext();
  if (!record || !record.messages) return null;

  return (
    <div className="max-h-[400px] overflow-y-auto flex flex-col gap-2 mt-4 p-4 border border-gray-300 rounded-xl bg-white">
      {record.messages.map((message) => (
        <div
          key={message.id}
          className={`max-w-[75%] p-3 rounded-lg flex-shrink-0 break-words whitespace-pre-line ${message.sender.id === record.buyer.id
            ? "bg-gray-200 text-black self-start"
            : "bg-blue-600 text-white self-end"
            }`}
        >
          <div className="flex flex-col">
            <span className="text-sm font-bold">
              {message.sender.name}{" "}
              <span className="text-xs">
                {message.sender.id === record.buyer.id
                  ? "(Consumer)"
                  : "(Supplier)"}
              </span>
            </span>
            <p className="text-base break-words">{message.content}</p>
            <span className="text-xs mt-1 opacity-70">
              {new Date(message.createdAt).toLocaleString()}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export const NegotiationShow = () => (
  <Show>
    <div className="p-4">
      {/* Compact Row Layout for Details */}
      <div className="w-full border p-6 rounded-xl shadow-xl bg-white mb-4">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Negotiation ID
            </Typography>
            <TextField source="id" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Type
            </Typography>
            <TextField source="type" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Trade Type
            </Typography>
            {/* <TextField source="tradeType" /> */}
             <TradeItemDialog source="itemId" />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" className="font-bold">
              Trade Item
            </Typography>
            <TradeItemDialog source="itemId" />
          </Grid> */}
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Quantity
            </Typography>
            <TextField source="quantity" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Buyer
            </Typography>
            {/* <TextField source="buyer.name" /> */}
            <UserDialog source="buyer" path="buyer" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Seller
            </Typography>
            <UserDialog source="seller" path="seller" />
            {/* <TextField source="seller.name" /> */}

          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Status
            </Typography>
            <TextField source="status" />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="subtitle2" className="font-bold">
              Created At
            </Typography>
            <DateField source="createdAt" />
          </Grid>
        </Grid>
      </div>

      <Divider className="my-4" />

      <Typography variant="h6" className="mb-4 font-bold">
        Messages
      </Typography>
      <MessagesList />
    </div>
  </Show>
);

const NegotiationCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [loading, setLoading] = useState(false);
  const [itemType, setItemType] = useState('Crop');
  const [tradeType, setTradeType] = useState('Offer');
  const [selectedItem, setSelectedItem] = useState(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handlePrevImage = () => {
    if (!itemDetails?.images?.length) return;
    setCurrentImageIndex((prev) => (prev === 0 ? itemDetails.images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    if (!itemDetails?.images?.length) return;
    setCurrentImageIndex((prev) => (prev === itemDetails.images.length - 1 ? 0 : prev + 1));
  };

  // Get the selected item details
  const { data: itemDetails } = useGetOne(
    itemType === 'Crop'
      ? 'offers'
      : itemType === 'Input'
        ? 'input-products'
        : 'services',
    { id: selectedItem },
    { enabled: !!selectedItem }
  );

  const offerFilter = useMemo(() => {
    // if (itemType === 'Crop') {
    //   return { offer_type: tradeType === 'Demand' ? 'sell' : 'buy' };
    // }
    if (itemType === 'Crop') {
      return { offer_type: tradeType === 'Demand' ? 'sell' : 'buy' };
    } else if (itemType === 'Input') {
      return { type: tradeType === 'Demand' ? 'sell' : 'buy' };
    } else if (itemType === 'Service') {
      return { service_type: tradeType === 'Demand' ? 'supply' : 'demand' };
    }
    return {};
  }, [itemType, tradeType]);

  return (
    <Create {...props} title="Create Negotiation (Admin)">
      <SimpleForm>
        <Grid container spacing={3}>
          {/* Left Column - Form */}
          <Grid item xs={12} md={6}>
            <Box mb={2}>
              <Typography variant="h6" gutterBottom>
                Negotiation Details
              </Typography>
              <Divider />
            </Box>

            <ReferenceInput
              source="actingAsUserId"
              reference="users"
              label="Acting on behalf of"
              validate={[required()]}
            >
              <AutocompleteInput optionText="name" fullWidth filterToQuery={q => ({ search: q, })} />
            </ReferenceInput>

            <SelectInput
              source="negotiationType"
              label="Negotiation Type"
              choices={[
                { id: 'Crop', name: 'Crop' },
                { id: 'Input', name: 'Agricultural Input' },
                { id: 'Service', name: 'Service' },
              ]}
              onChange={(e) => {
                setItemType(e.target.value);
                setSelectedItem(null);
              }}
              validate={[required()]}
              fullWidth
              margin="normal"
            />

            <SelectInput
              source="tradeType"
              label="Trade Type"
              choices={[
                { id: 'Offer', name: 'Offer' },
                { id: 'Demand', name: 'Demand' },
              ]}
              onChange={(e) => setTradeType(e.target.value)}
              validate={[required()]}
              fullWidth
              margin="normal"
            />

            {itemType === 'Crop' && (
              <ReferenceInput
                source="itemId"
                reference="offers"
                label="Select Crop Offer"
                filter={offerFilter}
                validate={[required()]}
              >
                <AutocompleteInput
                  optionText={(record) =>
                    `${record.offer} (${record.user?.name || ''})`
                  }
                  onChange={(id) => setSelectedItem(id)}
                  fullWidth
                  margin="normal"
                />
              </ReferenceInput>
            )}

            {itemType === 'Input' && (
              <ReferenceInput
                source="itemId"
                reference="input-products"
                label="Select Agricultural Input"
                filter={offerFilter}
                validate={[required()]}
              >
                <AutocompleteInput
                  optionText={(record) =>
                    `${record.input_category?.name} (${record.user?.name || ''})`
                  }
                  onChange={(id) => setSelectedItem(id)}
                  fullWidth
                  margin="normal"
                />
              </ReferenceInput>
            )}

            {itemType === 'Service' && (
              <ReferenceInput
                source="itemId"
                reference="services"
                label="Select Service"
                filter={offerFilter}
                validate={[required()]}
              >
                <AutocompleteInput
                  optionText={(record) =>
                    `${record.service?.name} (${record.user?.name || ''})`
                  }
                  onChange={(id) => setSelectedItem(id)}
                  fullWidth
                  margin="normal"
                />
              </ReferenceInput>
            )}

            <NumberInput
              source="quantity"
              label="Quantity"
              min={1}
              validate={[required()]}
              fullWidth
              margin="normal"
            />

            <SelectInput
              source="status"
              label="Initial Status"
              choices={[{ id: 'Active', name: 'Active' }]}
              defaultValue="Active"
              fullWidth
              margin="normal"
            />
          </Grid>

          {/* Right Column - Item Preview */}
          <Grid item xs={12} md={6}>
            <Card elevation={2}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Selected {itemType} Details
                </Typography>
                <Divider sx={{ mb: 2 }} />

                {selectedItem ? (
                  itemDetails ? (
                    <>
                      {itemDetails.images?.length > 0 && (
                        <Box position="relative" mb={2}>
                          <Box
                            component="img"
                            src={process.env.REACT_APP_URL + "/" + itemDetails.images[currentImageIndex]}
                            alt={`Offer Image ${currentImageIndex + 1}`}
                            sx={{
                              width: '100%',
                              height: 200,
                              objectFit: 'cover',
                              borderRadius: 2,
                            }}
                          />

                          {itemDetails.images.length > 1 && (
                            <>
                              <IconButton
                                onClick={handlePrevImage}
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: 8,
                                  transform: 'translateY(-50%)',
                                  backgroundColor: 'rgba(255,255,255,0.6)',
                                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                                }}
                              >
                                ◀
                              </IconButton>
                              <IconButton
                                onClick={handleNextImage}
                                sx={{
                                  position: 'absolute',
                                  top: '50%',
                                  right: 8,
                                  transform: 'translateY(-50%)',
                                  backgroundColor: 'rgba(255,255,255,0.6)',
                                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                                }}
                              >
                                ▶
                              </IconButton>
                            </>
                          )}
                        </Box>
                      )}

                      {itemType === 'Crop' && (
                        <>
                          <Typography>
                            <strong>Offer ID:</strong> {itemDetails.id}
                          </Typography>
                          <Typography>
                            <strong>Offer:</strong> {itemDetails.offer}
                          </Typography>
                          <Typography>
                            <strong>User:</strong> {itemDetails.user?.name || 'N/A'}
                          </Typography>
                          <Typography>
                            <strong>Type:</strong> {itemDetails.offer_type}
                          </Typography>
                          <Typography>
                            <strong>Quantity:</strong> {itemDetails.quantity}
                          </Typography>
                          <Typography>
                            <strong>Price:</strong> {itemDetails.price}
                          </Typography>
                        </>
                      )}
                      {itemType === 'Input' && (
                        <>
                          <Typography>
                            <strong>Category:</strong>{' '}
                            {itemDetails.input_category?.name || 'N/A'}
                          </Typography>
                          <Typography>
                            <strong>User:</strong> {itemDetails.user?.name || 'N/A'}
                          </Typography>
                        </>
                      )}
                      {itemType === 'Service' && (
                        <>
                          <Typography>
                            <strong>Service:</strong>{' '}
                            {itemDetails.service?.name || 'N/A'}
                          </Typography>
                          <Typography>
                            <strong>User:</strong> {itemDetails.user?.name || 'N/A'}
                          </Typography>
                        </>
                      )}
                    </>
                  ) : (
                    <Typography color="textSecondary">Loading details...</Typography>
                  )
                ) : (
                  <Typography color="textSecondary">
                    Please select an item to view details
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};


const required = (message = 'Required') => (value) =>
  value ? undefined : message;

export default NegotiationCreate;